import { useMutation } from '@apollo/client';
import type {
  TranslationFeedback_ReasonForFeedback as ReasonForFeedback,
  TranslationFeedback_TrackingInfo as TranslationFeedbackTrackingInfo,
} from '__generated__/graphql-types';

import { getUserLanguageCode } from 'js/lib/language';
import user from 'js/lib/user';

import TranslationFeedback from './TranslationFeedback.graphql';
import type {
  TranslationFeedback_ReportFeedbackMutation as TranslationFeedbackMutation,
  TranslationFeedback_ReportFeedbackMutationVariables as TranslationFeedbackVars,
} from './__generated__/TranslationFeedback';

const useGiveTranslationFeedback = (trackingInfo?: TranslationFeedbackTrackingInfo) => {
  const [mutate] = useMutation<TranslationFeedbackMutation, TranslationFeedbackVars>(TranslationFeedback);
  return (feedback: string, reasonsForFeedback: ReasonForFeedback[]) => {
    const languageCode = getUserLanguageCode();
    const userId = '' + user.get().id;
    const refererURL = location.href;

    mutate({
      variables: {
        input: {
          details: {
            feedback,
            reasonsForFeedback,
          },
          languageCode,
          refererURL,
          trackingInfo: trackingInfo ?? {},
          userId,
        },
      },
      context: { clientName: 'gatewayGql' },
    });
  };
};

export { useGiveTranslationFeedback };
